export const SCHEDULED_JOURNEY_MESSAGE =
    "Contacts will enter Journey at the scheduled time in trigger node. Updates will not impact any in-progress contacts.";

export const NON_SCHEDULED_JOURNEY_MESSAGE =
    "This will allow contacts to start entering the journey. Updates will not impact any in-progress contacts.";
